import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'

import {useErrorHandler} from '../../_metronic/helpers/ErrorHandler'
import {useAuth} from '../modules/auth'
import * as AuthService from '../modules/auth/services/AuthService'
import {acquireImpersonationHandoff, releaseImpersonationHandoff} from './impersonationTransport'

const LoginAs = () => {
  const navigate = useNavigate()
  const {errorHandler} = useErrorHandler()
  const {saveAuth, setCurrentUser} = useAuth()
  const [handoff] = useState(() => acquireImpersonationHandoff())
  const exchangePromiseRef = useRef(null)
  const mountedRef = useRef(false)
  const handlersRef = useRef({errorHandler, navigate, saveAuth, setCurrentUser})
  handlersRef.current = {errorHandler, navigate, saveAuth, setCurrentUser}

  useEffect(() => {
    mountedRef.current = true

    const load = async () => {
      const handlers = handlersRef.current
      try {
        if (!handoff.token) {
          handlers.navigate('/gis', {
            replace: true,
            state: {impersonationError: handoff.reason},
          })
          return
        }

        const exchange = await handlers.errorHandler(
          AuthService.exchangeImpersonationHandoff(handoff.token),
          [401, 403, 422]
        )
        const sessionToken = exchange?.data?.access_token
        if (!mountedRef.current) {
          return
        }
        if (!exchange?.ok || !sessionToken) {
          handlers.navigate('/gis', {
            replace: true,
            state: {impersonationError: 'handoff_rejected'},
          })
          return
        }

        const profile = await handlers.errorHandler(AuthService.me(sessionToken), [401, 403, 422])
        if (!mountedRef.current) {
          return
        }
        if (!profile?.ok || !profile?.data?.data) {
          handlers.navigate('/gis', {
            replace: true,
            state: {impersonationError: 'session_validation_failed'},
          })
          return
        }

        handlers.saveAuth({api_token: sessionToken})
        handlers.setCurrentUser(profile.data.data)
        handlers.navigate('/gis', {replace: true})
      } catch (error) {
        if (mountedRef.current) {
          handlers.navigate('/gis', {
            replace: true,
            state: {impersonationError: 'token_rejected'},
          })
        }
      } finally {
        releaseImpersonationHandoff(handoff)
      }
    }

    if (!exchangePromiseRef.current) {
      exchangePromiseRef.current = load()
    }
    return () => {
      mountedRef.current = false
    }
  }, [handoff])

  return null
}

export default LoginAs
